import { gql, type TypedDocumentNode } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Collection } from '@sorare/core/src/atoms/icons/Collection';
import { isType, isTypes } from '@sorare/core/src/lib/gql';

import { MissionSection } from '#src/components/missions/MissionSection/index.tsx';

import { TaskCards } from './TaskCards';
import { TaskCollections } from './TaskCollections';
import type { TaskCardsOrCollections_taskInterface } from './__generated__/index.graphql';

type Props = {
  task: TaskCardsOrCollections_taskInterface;
};

export const TaskCardsOrCollections = ({ task }: Props) => {
  if (
    !isTypes(task, [
      'CardsCountTargetTask',
      'CompleteCollectionsCountTargetTask',
    ])
  ) {
    return null;
  }

  return (
    <MissionSection
      icon={<Collection size={2} />}
      iconColor="var(--c-white)"
      title={<FormattedMessage defaultMessage="My collection" />}
    >
      {isType(task, 'CardsCountTargetTask') ? (
        <TaskCards task={task} />
      ) : (
        <TaskCollections task={task} />
      )}
    </MissionSection>
  );
};

TaskCardsOrCollections.fragments = {
  taskInterface: gql`
    fragment TaskCardsOrCollections_taskInterface on TaskInterface {
      id
      ...TaskCards_taskInterface
      ...TaskCollections_taskInterface
    }
    ${TaskCards.fragments.taskInterface}
    ${TaskCollections.fragments.taskInterface}
  ` as TypedDocumentNode<TaskCardsOrCollections_taskInterface>,
};
